import { ExclamationCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import PropTypes from 'prop-types';
import { useRef, memo } from 'react';
import { ScrollButtonContainer, ScrollContainer } from './styles';

function AlertSection({ alerts, alertsLoading, handleViewAlert }) {
	const scrollContainerRef = useRef(null);

	const scrollLeft = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollBy({ left: -660, behavior: 'smooth' });
		}
	};

	const scrollRight = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollBy({ left: 660, behavior: 'smooth' });
		}
	};

	return (
		<div style={{ marginTop: '25px' }}>
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<h3>Alerts</h3>
				{alerts.length > 0 && (
					<ScrollButtonContainer>
						<Button
							type="default"
							icon={<LeftOutlined />}
							onClick={scrollLeft}
							style={{ marginRight: '8px' }}
						/>
						<Button type="default" icon={<RightOutlined />} onClick={scrollRight} />
					</ScrollButtonContainer>
				)}
			</div>
			<ScrollContainer ref={scrollContainerRef}>
				{alertsLoading && (
					<div style={{ padding: '20px', textAlign: 'center' }}>Loading alerts...</div>
				)}
				{!alertsLoading && alerts.length === 0 && (
					<div style={{ padding: '20px', textAlign: 'center' }}>No alerts found</div>
				)}
				{!alertsLoading &&
					alerts.length > 0 &&
					alerts.map((alert) => (
						<Card
							key={alert.id}
							style={{
								width: 240,
								display: 'inline-block',
								margin: '0 10px',
								borderRadius: '4px',
								backgroundColor: '#FFF1F0',
								borderColor: '#FFA39E',
								cursor: 'pointer',
							}}
							onClick={() => handleViewAlert(alert)}
						>
							<div style={{ textAlign: 'center', color: '#FF4D4F' }}>
								<ExclamationCircleOutlined
									style={{ fontSize: '18px', marginRight: '5px' }}
								/>
								<span style={{ fontWeight: 'bold' }}>BREACH</span>
							</div>
							<div style={{ marginTop: '10px', textAlign: 'center' }}>
								<small>
									<span style={{ fontWeight: 'bold' }}>Vehicle No.</span>{' '}
									{alert.vehicle_number}
								</small>
							</div>
							<div style={{ marginTop: '8px', textAlign: 'center' }}>
								<small>
									<span style={{ fontWeight: 'bold' }}>Driver No.</span>{' '}
									{alert.driver_number}
								</small>
							</div>
						</Card>
					))}
			</ScrollContainer>
		</div>
	);
}

export default memo(AlertSection);

AlertSection.propTypes = {
	alerts: PropTypes.array.isRequired,
	alertsLoading: PropTypes.bool.isRequired,
	handleViewAlert: PropTypes.func.isRequired,
};
